import { Button, Modal, Space, message, Upload } from "antd"
import { UploadOutlined } from "@ant-design/icons"
import type { UploadProps } from "antd"
import { RcFile } from "antd/es/upload/interface"
import api from "../../services/api"
import { useState } from "react"
import axios from "axios"

type ModalPaymentProps = {
    handleOk: () => void
    setIsModalOpen: (value: boolean) => void
    isModalOpen: boolean
}

export function ModalAddPicture(props: ModalPaymentProps) {
    const isSquareImage = async (file: RcFile): Promise<boolean> => {
        return new Promise((resolve) => {
            const reader = new FileReader()
            reader.onload = (e) => {
                const img = new Image()
                img.onload = () => {
                    resolve(img.width === img.height)
                };
                img.src = e.target?.result as string
            };
            reader.readAsDataURL(file)
        })
    }
    const beforeUpload = async (file: RcFile) => {
        const isPNG = (file.type === "image/png" || file.type === "image/jpeg")
        if (!isPNG) {
            message.error("Você só pode enviar arquivos PNG ou JPG! Mas enviou um "+file.type)
            return Upload.LIST_IGNORE
        }
        const maxSizeInBytes = 1024 * 1024; // 1 MB
        if (file.size > maxSizeInBytes) {
            message.error("O tamanho da foto deve ser menor que 1 MB.");
            return Upload.LIST_IGNORE;
        }
        if (!(await isSquareImage(file))) {
            message.error("A foto deve ser quadrada (mesma largura e altura).");
            return Upload.LIST_IGNORE;
        }
    }

    const propsUpload: UploadProps = {
        name: "file",
        customRequest: async ({ file, onSuccess, onError }) => {
            const formData = new FormData();
            formData.append("file", file);
            try {
                const response = await api.post("picture/upload", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                if (response.status === 200) {
                    onSuccess && onSuccess("Upload concluído.")
                    message.success(`${(file as RcFile).name} enviado com sucesso.`)
                    props.handleOk()
                }

            } catch (error) {
                onError && onError(error as Error)
                message.error(`${(file as RcFile).name} falhou ao enviar.${error}`)
            }
        },
        beforeUpload,
        showUploadList: true,
    }

    return (
        <Modal
            title="Inserir Nova Foto"
            open={props.isModalOpen}
            onCancel={props.handleOk}
            footer={null}
        >
            <Space direction="vertical">
                <Upload {...propsUpload}>
                    <Button icon={<UploadOutlined />}>Clique para Enviar</Button>
                </Upload>
            </Space>
        </Modal>
    )
}
